module.exports = __webpack_public_path__ + "img/insert.39d43779.svg";